<template>
	<div>
		<j-base-multi-select-with-flexible-value
			:id="id"
			:options="options"
			:value="value"
			:placeholder="placeholder ? placeholder : $t('search')"
			:allowLocalSearch="false"
			:allowMultiselect="allowMultiselect"
			:status="status"
			:size="size"
			valueKey="id"
			nameKey="name"
			@input="onInput($event)"
			@search="onSearch($event)"
		/>
	</div>
</template>

<script>
import JBaseMultiSelectWithFlexibleValue from "@/components/JBaseMultiSelectWithFlexibleValue"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"
import debounce from "lodash.debounce"

export default {
	components: { JBaseMultiSelectWithFlexibleValue },
	props: {
		value: {
			validator(value) {
				return value === null || value instanceof Array
			},
			required: true,
			default: () => []
		},
		id: {
			type: String,
			required: false
		},
		status: {
			type: String,
			required: false
		},
		size: {
			type: String,
			required: false,
			default: "medium"
		},
		allowMultiselect: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: null
		},
		valuesVisibleOnLoad: {
			type: Boolean,
			default: true
		}
	},

	data() {
		return {
			options: []
		}
	},

	methods: {
		onInput(value) {
			this.$emit("input", value)
		},

		onSearch: debounce(async function(searchTerm = null) {
			const query = gql`
				query binders($where: binderWhereInput) {
					binders(where: $where) {
						list {
							id
							name
							facts {
								type
								value {
									stringValue
								}
							}
						}
					}
				}
			`

			const sort = { fieldName: "name", type: "asc" }
			let res = await api({ query, variables: { sort } })

			// HACK binderNumber is defined as fact, we agreed on this with Bambi
			// It feels hacky as facts don't have stron definition anywhere
			// We also filter frontend side base on that fact
			this.options = res?.data?.binders?.list
				?.filter(item =>
					item?.facts
						?.find(fact => fact.type === "binderNumber")
						?.value?.stringValue.includes(searchTerm)
				)
				?.map(item => {
					const fact =
						item?.facts?.find(fact => fact.type === "binderNumber")?.value
							?.stringValue || ""

					return {
						name: `${fact ? fact : ""}`,
						id: item.id
					}
				})
		}, 500)
	},

	created() {
		if (this.valuesVisibleOnLoad === true) {
			this.onSearch("") // insert '' in multiselect search bar to trigger/return all values without typing anything
		}
	}
}
</script>
